import { render, staticRenderFns } from "./translate-menu.component.vue?vue&type=template&id=40d48c7c&scoped=true&"
import script from "./translate-menu.component.vue?vue&type=script&lang=ts&"
export * from "./translate-menu.component.vue?vue&type=script&lang=ts&"
import style0 from "./translate-menu.component.vue?vue&type=style&index=0&id=40d48c7c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d48c7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu})
